<template>
  <v-flex>
    <v-toolbar
        dark
        fixed
        flat
        :class="$route.meta.colorToolbar === 'gradient' ? 'gradient' : ''"
        :app="$route.meta.colorToolbar === 'black'"
        clipped-right
        scroll-off-screen
    >
      <img
          :src="require('@/assets/img/innovation/nttdata_bianco.png')"
          :width="tabletAndDown() ? 50 : 150"
          @click="navigate( '/homepage' )"
          height="auto"
      />
      <v-spacer></v-spacer>
      <v-btn :large="!tabletAndDown()" :small="tabletAndDown()" flat dark @click="navigate('/homepage')">HOME</v-btn>
      <!--<v-btn v-if="!tabletAndDown()" large flat dark @click="navigate('/discoverChallenges')">Challenges</v-btn>
      <v-btn v-if="!tabletAndDown()" large flat dark @click="navigate('/startup/registration')">Retriever</v-btn>-->
      <v-menu v-if="!tabletAndDown()" open-on-hover down offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
              large flat dark
              v-on="on"
          >
            Startup-related services
          </v-btn>
        </template>

        <v-list dark style="background: rgba(0, 0, 0, 0.43);">
          <v-list-tile class="tile" @click="navigate('/discoverChallenges')">
            <v-icon class="mr-2">fa-chevron-right</v-icon>
            <v-list-tile-title>Challenges</v-list-tile-title>
          </v-list-tile>
          <v-list-tile class="tile" @click="navigate('/startup/registration')">
            <v-icon class="mr-2">fa-chevron-right</v-icon>
            <v-list-tile-title>Registration</v-list-tile-title>
          </v-list-tile>
          <v-list-tile class="tile" @click="navigate('/startup/modification')">
            <v-icon class="mr-2">fa-chevron-right</v-icon>
            <v-list-tile-title>Edit your startup information</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-btn :large="!tabletAndDown()" :small="tabletAndDown()" flat dark @click="navigate('/discoverNews')" class="news">NEWS</v-btn>
      <v-spacer></v-spacer>

      <v-toolbar-items>
        <!-- HELP BUTTON -->
        <v-btn :icon="tabletAndDown()"
               flat
               small
               @click="navigateHelp()"
        >
          <span class="hidden-sm-and-down pr-2">HELP</span>
          <v-icon :right="!tabletAndDown">
            mdi-help-circle-outline
          </v-icon>
        </v-btn>
        <v-btn :large="!tabletAndDown()" :small="tabletAndDown()" :icon="tabletAndDown()" flat dark
               @click="enableLogin = true">
          <v-flex v-if="!tabletAndDown()">NTT DATA & Customers</v-flex>
          <v-icon medium dark>mdi-account</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-navigation-drawer
        v-model="enableLogin"
        temporary
        app
        right
        width="500"
        disable-resize-watcher
        dark
    >
      <v-flex mr-3 pr-3 pt-3 v-if="tabletAndDown()" class="text-xs-right">
        <v-btn icon @click="enableLogin=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-flex>
      <v-card class="ma-3 pa-3 elevation-0">
        <v-card-title>
          <span class="headline">Enter credential to use NTT DATA Discovery</span>
        </v-card-title>
        <v-card-text>
          <v-form
              ref="form"
              v-model="loginIsValid"
              lazy-validation
          >
            <v-text-field
                v-model="username"
                :counter="32"
                :error-messages="usernameErrors"
                label="Username"
                required
                @keyup.13="loginUser()"
                @input="$v.username.$touch()"
                @blur="$v.username.$touch()"></v-text-field>
            <v-text-field
                v-model="password"
                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                :type="showPassword ? 'text' : 'password'"
                :error-messages="passwordErrors"
                label="Password"
                required
                @keyup.13="loginUser()"
                @click:append="showPassword = !showPassword"
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"></v-text-field>
            <div class="text-xs-center py-3">
              <v-btn
                  :disabled="!loginIsValid"
                  outline
                  dark
                  @click="loginUser()"
              >
                Login
              </v-btn>
            </div>
          </v-form>
          <v-flex xs12 py-5>
            <span class="title">If you have lost or forgotten your password <a style="color: red"
                                                                               href="mailto:nttdata.discovery@nttdata.com?subject=Password%20request">contact</a> the NTT DATA Discovery administrators.</span>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </v-flex>
</template>

<script>
import RouterService from "@/helpers/RouterService";
import {validationMixin,} from "vuelidate";
import {maxLength, minLength, required,} from "vuelidate/lib/validators";
import UrlsService from "@/helpers/UrlsService";
import TimeService from "@/helpers/TimeService";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
import NotificationService from "@/helpers/NotificationService";
import {mapGetters} from "vuex";

export default {
  name: "AppToolbarInnovationPublic",
  components: {},
  mixins: [validationMixin,],
  validations: {
    username: {required, minLength: minLength(3), maxLength: maxLength(32),},
    password: {required, minLength: minLength(8),},
  },
  data() {
    return {
      loginIsValid: false,
      username: "",
      password: "",
      showPassword: false,
      enableLogin: false,
    };
  },
  computed: {
    usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      !this.$v.username.minLength && errors.push("Username must be at least 3 characters long");
      !this.$v.username.maxLength && errors.push("Username must be at most 32 characters long");
      !this.$v.username.required && errors.push("Username is required.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength && errors.push("Password must be at least 8 characters long");
      !this.$v.password.required && errors.push("Password is required");
      return errors;
    },
    ...mapGetters('UserState', {
          settings: 'getSettings',
          userInfo: 'getUserInfo',
        }
    ),
    ...mapGetters('AppState', {
          availableLocales: 'getAvailableLocales',
          userChatbotSettings: 'getSettings'
        }
    ),
  },
  methods: {
    tabletAndDown() {
      return this.$vuetify.breakpoint.name === "xs" ||
          this.$vuetify.breakpoint.name === "sm";
    },
    navigate(path) {
      RouterService.goTo(path);
    },
    navigateHelp() {
      let path = {
        name: "Help-startup",
        params: {
          public: true
        },
      };
      RouterService.goTo(path);
    },
    loginUser() {
      if (this.loginIsValid) {
        this.$v.$touch();
        let requestUrl = {
          url: UrlsService.doLogin,
          timeout: TimeService.secondsToMillis(0),
        };
        let requestBody = {
          username: this.username,
          password: this.password,
        };
        let requestObject = {
          type: "login",
          urlsInfo: requestUrl,
          data: {
            data: requestBody,
          },
        };
        let messages = {
          title: "Login",
          loading: "Waiting for login...",
          error: "Login failed",
        };
        let options = {
          loadingType: "no",
          timeout: TimeService.secondsToMillis(0),
        };
        
        console.debug("SPLASHSCREEN - URL:", UrlsService.doLogin)
        APILoaderDecoratorService.setLoader(requestObject, messages, options)
            .then(responseSuccess => {
              let response = responseSuccess;
              console.debug("SPLASHSCREEN - Logged user: ", response);
              if (response.response !== undefined && response.response.status === 401) {
                this.loginState = "form";
                this.username = "";
                this.password = "";
                console.error("SPLASHSCREEN - Login error: ", response);
              } else {
                let userInfo = {
                  isLogged: true,
                  name: response.firstName,
                  surname: response.lastName,
                  username: response.username,
                  role: response.role,
                  email: response.email,
                  scenarioId: response.scenarioId,
                  scenarioList: response.scenarioList,
                  token: response.token,
                  groupId: response.groupId
                };

                let settings = {
                  buttons: response.settings.buttons,
                  chatLanguage: response.settings.chatLanguage,
                  notificationsType: {
                    previous: {
                      value: response.settings.notificationsType,
                      description: response.settings.notificationsTypeDescription
                    },
                    current: {
                      value: response.settings.notificationsType,
                      description: response.settings.notificationsTypeDescription
                    },
                  },
                  notificationsCountry: response.settings.notificationsCountry,
                  notificationsIndustry: response.settings.notificationsIndustry,
                  notificationsTech: response.settings.notificationsTech,
                  notificationsOpco: response.settings.notificationsOpco,

                };
                this.$store.dispatch("UserState/setUserInfo", userInfo);
                this.$store.dispatch("AppState/setHasSplashed", true);
                this.$store.dispatch("AppState/setSettings", settings);
                let locale = this.selectChatbotLocale(response.settings.chatLanguage)[0]
                if (locale !== undefined && locale !== null && locale !== "") {
                  this.settings.chatbot.language.current = locale;
                }
                this.userChatbotSettings.buttons = response.settings.buttons

                this.userChatbotSettings.notificationsCountry = response.settings.notificationsCountry
                this.userChatbotSettings.notificationsIndustry = response.settings.notificationsIndustry
                this.userChatbotSettings.notificationsTech = response.settings.notificationsTech
                this.userChatbotSettings.notificationsOpco = response.settings.notificationsOpco

                NotificationService.reset();
                RouterService.goToDefaultPath();
              }
            })
            .catch(responseError => {
              this.loginState = "form";
              this.username = "";
              this.password = "";
              console.error("SPLASHSCREEN - Login error: ", responseError);
            });
      }

    },
    selectChatbotLocale: function (chatbotLanguage) {
      return this.availableLocales.filter(function (element) {
        return element.locale === chatbotLanguage
        //|| element.locale === 'auto'
      })
    },

  },
};
</script>

<style lang="scss" scoped>

.transparent {
  background-color: transparent !important;
}

.gradient {
  background: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
}

.tile {
  background: transparent;
  margin: 5px;
  border-radius: 4px;
}

.tile:hover {
  background: black;
}

.news{
  font-weight: bold;
  font-size: large;
}

</style>
